import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query'
import App from './App.vue'
import router from '@/router'
import { useAuthStore } from '@/stores/auth'
import './style.css'

const app = createApp(App)

app.use(createPinia())
app.use(router)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 30, // 30秒。少人数・低頻度利用のため頻繁な自動再取得は不要
    },
  },
})
app.use(VueQueryPlugin, { queryClient })

// 認証状態の初期化(Cognitoからのコールバック処理を含む)を終えてからマウントする。
//
// 【重要】stores/auth.ts の initialize() は、コールバック処理後に
// window.history.replaceState() で "/" にURLを書き換えているが、これは
// ブラウザの履歴APIを直接操作するだけで、Vue Router自身の内部状態には
// 反映されない(popstateイベントも発火しない)。Vue Routerは createRouter()
// 実行時点(この時点ではまだURLが /callback?code=... のまま)のURLを基準に
// 初期ルート解決を行おうとするため、対応するルートが存在せず、
// マウント後に画面が真っ白になっていた(画面更新すると正しく表示されるのは、
// 再読み込み時には既にURLが "/" に書き換わった後の状態から
// Vue Routerが初期化されるため)。
// これを防ぐため、認証初期化が完了した時点で、Vue Router自身にも
// 現在の実際のURLへ明示的に再同期させてからマウントする。
const authStore = useAuthStore()
authStore.initialize().finally(async () => {
  await router.replace(window.location.pathname + window.location.search)
  app.mount('#app')
})
